import { useDroppable } from '@dnd-kit/core'

import { EMPTY_OBJECT } from '../../../constants/common'
import { DRAG_DROP_DATA_ATTR } from '../DragDrop.constants'

function DragDropDroppableArea({
  children,
  data = EMPTY_OBJECT,
  disabled,
  id,
  ...restProps
}) {
  const { isOver, setNodeRef } = useDroppable({
    data,
    disabled,
    id,
  })

  return (
    <div
      {...restProps}
      {...{
        [DRAG_DROP_DATA_ATTR.isOver]: isOver,
      }}
      ref={setNodeRef}
    >
      {children}
    </div>
  )
}

export default DragDropDroppableArea
